import type { ReactNode } from "react"
import { cn } from "@/lib/utils"

interface ColumnProps {
  title: string
  children: ReactNode
  className?: string
  titleClassName?: string // Add this new prop
}

function Column({ title, children, className, titleClassName }: ColumnProps) {
  return (
    <div className={cn("flex flex-col items-center text-center", className)}>
      <h2 className={cn("text-2xl font-bold text-gray-900 mb-4 tracking-tight font-funnel", titleClassName)}>
        {title}
      </h2>
      <div className="space-y-4">{children}</div>
    </div>
  )
}

interface ThreeColumnSectionProps {
  columns: {
    title: string
    content: ReactNode
  }[]
  className?: string
  titleClassName?: string // Add this new prop
}

export function ThreeColumnSection({ columns, className, titleClassName }: ThreeColumnSectionProps) {
  return (
    <div className={cn("w-full grid grid-cols-1 md:grid-cols-3 gap-8 md:gap-12", className)}>
      {columns.map((column, index) => (
        <Column key={index} title={column.title} titleClassName={titleClassName}>
          {column.content}
        </Column>
      ))}
    </div>
  )
}
